import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="trouble-tickets--batch-edit"
export default class extends Controller {
  connect() {
    this.ids = []
    this.dialogElement = document.querySelector('dialog#batchEdit')
    this.form = this.dialogElement.querySelector('form')

    this.element.addEventListener('click', (e) => {
      e.preventDefault();
      if(this.ids.length > 0) {
        this._addDatagridParams()
        this.dialogElement.dataset.dialogMode = "modal"
        this.dialogElement.showModal()
      } else {
        alert('Please select at least one problem report')
      }
    })

    document.querySelector('.datagrid').addEventListener('datagrids--table:selection-changed', (event) => {
      this.ids = event.detail.selectedRows
      this.form.querySelectorAll('input[type="hidden"][name="ids[]"]').forEach((field) => field.remove())
      this.ids.forEach((id) => this._addHiddenField('ids[]', id))
    })
  }

  _addDatagridParams() {
    // Remove old datagrid params
    this.form.querySelectorAll('input[type="hidden"][name^="trouble_tickets_datagrid"]').forEach((field) => field.remove())

    // Get current URL params
    const urlParams = new URLSearchParams(window.location.search)

    // Add all trouble_tickets_datagrid params from URL
    for (let [key, value] of urlParams.entries()) {
      if (key.startsWith('trouble_tickets_datagrid')) {
        this._addHiddenField(key, value)
      }
    }
  }

  _addHiddenField(name, value) {
    let field = document.createElement('input')
    field.setAttribute('type', 'hidden')
    field.setAttribute('name', name)
    field.setAttribute('value', value)
    this.form.appendChild(field)
  }
}
